<template>
      <b-modal 
        id="form-challenge" 
        modal-class='form form-challenge'
        modal-footer="hide"
        scrollable
        centered 
        :title="formContent.formModalTitle"
        >
        <div class="form form__addChallenge">
        <b-form @submit="onSubmit" @reset="onReset">
            <!-- TITLE -->
            <b-form-group
              id="input-group-1"
              :label="formContent.formTitle"
              label-for="challenge-title"
            >
              <b-form-input
                id="challenge-title"
                v-model="form.title"
                required
                :placeholder="formContent.formTitlePlaceholder"
              ></b-form-input>
            </b-form-group>   

            <!-- REFERENCE -->
            <b-form-group
              id="input-group-2"
              :label="formContent.formRef"
              label-for="challenge-ref"
            >
            <div class="btnGroup" id="challenge-ref">
              <b-button class="btn-modal select" @click="toggleButtons">{{formContent.formRefBtOne}}</b-button>
              <b-button class="btn-modal" @click="toggleButtons">{{formContent.formRefBtTwo}}</b-button>
              <b-button class="btn-modal" @click="toggleButtons">{{formContent.formRefBtThree}}</b-button>
            </div>
            </b-form-group>  


            <!-- CATEGORIE & CRITERIA -->
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-3"
                  :label="formContent.formCat"
                  label-for="challenge-select"
                >

                <div class="select__wrapper">
                  <font-awesome-icon :icon="['far', 'chevron-down']" />
                  <b-form-select  id="challenge-select" v-model="form.cat" :options="cat" class="select" required>
                  </b-form-select>
                </div>

                </b-form-group>  
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-4"
                  :label="formContent.formCriteria"
                  label-for="challenge-criteria"
                >
                <div class="select__wrapper">
                  <font-awesome-icon :icon="['far', 'chevron-down']" />
                  <b-form-select  id="challenge-criteria" v-model="form.criteria" :options="criteria" class="select" required>
                  </b-form-select>
                </div>


                </b-form-group>  
              </b-col>
            </b-row>


            <!-- DATES START & END -->
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-5"
                  :label="formContent.formStart"
                  label-for="challenge-start"
                >
                  <b-form-datepicker 
                  id="challenge-start" 
                  v-model="form.start" 
                  :placeholder="formContent.formDatePlaceholder"
                  >
                  </b-form-datepicker>
                </b-form-group>  
              </b-col>
              <b-col sm="12" lg="6">
                <b-form-group
                  id="input-group-6"
                  :label="formContent.formEnd"
                  label-for="challenge-end"
                >
                  <b-form-datepicker 
                  id="challenge-end" 
                  v-model="form.end" 
                  :placeholder="formContent.formDatePlaceholder"
                  >
                  </b-form-datepicker>
                </b-form-group>   
              </b-col>
            </b-row>

            <!-- OBJECTIF -->
            <b-row>
              <b-col sm="12" lg="6">            
                <b-form-group
                  id="input-group-7"
                  :label="formContent.formObjectif"
                  label-for="challenge-objectif"
                >
                  <b-form-input
                    id="challenge-objectif"
                    v-model="form.objectif"
                    required
                    :placeholder="formContent.formObjectifPlaceholder"
                  ></b-form-input>
                </b-form-group> 
              </b-col>
            </b-row>
         </b-form>       
        </div>



      <template v-slot:modal-footer>
          <b-button
          @click="closeMe()"
          class="btn-cancel"
          >
            {{formContent.formBtCancel}}
          </b-button>
          <b-button
            @click="addChallenge()"
            class="btn-challenges"
          >
            {{formContent.formBtCreate}}
          </b-button>
      </template>

      </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'



export default {
  name: "FormChallenge",
  components: {
  },
  props:{
  },
  data() {
    return {
        form: {
          title: '',
          cat: '',
          criteria: '',
          start: '',
          end: '',
          objectif: null,
          checked: []
        },
        cat: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
        criteria: [{ text: 'Select One', value: null }, 'Carrots', 'Beans', 'Tomatoes', 'Corn'],
    }
  },
  computed: {
    ...mapGetters([
        'getGeneral',
    ])
  },
  created (){
    this.formContent = this.getGeneral;
    console.log('POPUP CREATED');
  },  
  methods:{
      onSubmit(evt) {
        evt.preventDefault()
        alert(JSON.stringify(this.form))
      },
      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.form.email = ''
        this.form.name = ''
        this.form.food = null
        this.form.checked = []
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      } ,
      closeMe(){
        this.$root.$emit('bv::hide::modal', 'form-challenge');
      }, 
      addChallenge(){
        console.log('ADD CHALLENGE');
      },  
      toggleButtons(e){
        // const buttons = this.$el.querySelectorAll('.btn-modal');
        const buttons = document.querySelectorAll('.btn-modal');
        buttons.forEach(button => {
            button.classList.remove('select');
        });
        e.currentTarget.classList.add('select');
      }
  }  
}
</script>

